// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faGoogle } from '@fortawesome/free-brands-svg-icons';
import '../styles/Footer.css';
import logo from '../assets/logo.png';

const Footer = () => (
  <footer className="footer">
    <div className="footer__grid">

      {/* Brand */}
      <div>
        <img src={logo} alt="Lebua Thai" className="footer__brand-logo" />
        <p className="footer__tagline">
          Authentic Thai cuisine in the heart of<br />Singapore's historic CHIJMES.
        </p>
        <div className="footer__social">
          <a
            href="https://www.facebook.com/profile.php?id=61556215584916"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a
            href="https://www.instagram.com/lebua_thai/"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            href="https://g.co/kgs/Ct72hTQ"
            className="footer__social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Google"
          >
            <FontAwesomeIcon icon={faGoogle} />
          </a>
        </div>
      </div>

      {/* Navigation */}
      <div>
        <p className="footer__col-title">Explore</p>
        <ul className="footer__links">
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/menu">Menu</Link></li>
          <li><Link to="/reservation">Reservation</Link></li>
          <li><Link to="/promotion">Promotions</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/testimonials">Reviews</Link></li>
          <li><Link to="/hours">Operating Hours</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/legal">Legal</Link></li>
        </ul>
      </div>

      {/* Contact */}
      <div>
        <p className="footer__col-title">Find Us</p>
        <div className="footer__contact">
          <p>
            30 Victoria Street<br />
            #01-31 CHIJMES<br />
            Singapore 187996
          </p>
          <div className="footer__contact-block">
            <a href="tel:+6590079953">+65 9007 9953</a>
            <a href="mailto:lebua.thai@gmail.com">lebua.thai@gmail.com</a>
          </div>
          <p style={{ marginTop: '1rem' }}>
            Mon–Sun: 11:30 AM – 3:00 PM<br />
            &amp; 5:30 PM – 11:00 PM<br />
            Last Orders: 10:00 PM
          </p>
        </div>
      </div>

    </div>

    <div className="footer__bottom">
      <p>&copy; {new Date().getFullYear()} Lebua Thai. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
